// อักขระที่มองไม่เห็น/ไม่มีความกว้าง (zero-width, bidi control, BOM ฯลฯ) — ไม่มีประโยชน์ในรหัสโครงการ
const INVISIBLE_CODES = [
  0x200B, 0x200C, 0x200D, 0x200E, 0x200F,
  0x202A, 0x202B, 0x202C, 0x202D, 0x202E,
  0x2060, 0x2061, 0x2062, 0x2063, 0x2064,
  0x2066, 0x2067, 0x2068, 0x2069,
  0xFEFF, 0x00AD, 0x061C,
];
// ช่องว่างพิเศษที่หน้าตาเหมือนเว้นวรรคปกติแต่เป็นคนละตัวอักษร (มักติดมาจากการ copy จาก Word/Excel/PDF)
const WEIRD_SPACE_CODES = [
  0x00A0, 0x1680,
  0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A,
  0x202F, 0x205F, 0x3000,
];
// backtick ทำให้ข้อความพัง ตอน render เป็น markdown ในหน้าที่เรียกใช้ project_number (เช่นข้อความแจ้งเตือน LINE/Discord)
const BACKTICK_CODE = 0x60;
// สระบน/สระล่าง/วรรณยุกต์ไทย — ปกติเกาะบนตัวอักษรนำหน้าจึงเห็นได้ปกติ แต่ถ้า "ลอย" (ไม่มีตัวนำหน้าให้เกาะ
// เช่นพิมพ์วรรณยุกต์ก่อนพยัญชนะ หรือ paste ข้อความที่ถูกตัดหัวคำมา) จะไม่มีจุดวาด กลายเป็นไม่มีอะไรแสดงเลย เหมือน zero-width char
const THAI_COMBINING_MARK_CODES = [
  0x0E31, 0x0E34, 0x0E35, 0x0E36, 0x0E37, 0x0E38, 0x0E39, 0x0E3A,
  0x0E47, 0x0E48, 0x0E49, 0x0E4A, 0x0E4B, 0x0E4C, 0x0E4D, 0x0E4E,
];

const INVISIBLE_SET = new Set(INVISIBLE_CODES);
const WEIRD_SPACE_SET = new Set(WEIRD_SPACE_CODES);
const THAI_COMBINING_MARK_SET = new Set(THAI_COMBINING_MARK_CODES);

// ตัวแทนอักขระที่มีปัญหา (Unicode replacement character) — เลือกตัวนี้เพราะ browser รับประกันว่าเรนเดอร์ได้เสมอ
// ทำให้อักขระที่ตัวจริงไม่มีความกว้าง (มองไม่เห็นในช่องกรอกเด็ดขาด) กลายเป็นสิ่งที่เห็นได้จริงตรงตำแหน่งเดิม แทนที่จะลบทิ้งเงียบๆ
const MARKER = String.fromCodePoint(0xFFFD);

const CHAR_NAMES = {
  [BACKTICK_CODE]: 'แบ็กทิก (`)',
  0x00A0: 'เว้นวรรคแบบไม่ตัดคำ (NBSP)',
  0x200B: 'ช่องว่างล่องหน (Zero Width Space)',
  0x200C: 'Zero Width Non-Joiner',
  0x200D: 'Zero Width Joiner',
  0x200E: 'Left-to-Right Mark',
  0x200F: 'Right-to-Left Mark',
  0xFEFF: 'Zero Width No-Break Space (BOM)',
  0x3000: 'เว้นวรรคแบบเต็มความกว้าง (Ideographic Space)',
};

function describeCode(code) {
  return CHAR_NAMES[code] || `อักขระที่มองไม่เห็น (U+${code.toString(16).toUpperCase().padStart(4, '0')})`;
}

// แทนที่อักขระล่องหน/เว้นวรรคแปลก/backtick/สระวรรณยุกต์ลอย ด้วย MARKER ที่มองเห็นได้จริงตรงตำแหน่งเดิมในข้อความ
// (ไม่ลบทิ้งเงียบๆ) พร้อมสรุปว่าเจออะไรบ้างให้ผู้ใช้เห็นทันทีและลบเองได้
export function sanitizeIdentifier(raw) {
  if (!raw) return { cleaned: raw, foundDescriptions: [] };

  const foundCodes = new Set();
  let cleaned = '';
  let hasBase = false; // มีตัวอักษรที่ใช้เป็นฐานให้สระ/วรรณยุกต์เกาะได้แล้วหรือยัง (นับ MARKER ที่แทนไปด้วย)
  for (const ch of raw) {
    const code = ch.codePointAt(0);
    const isKnownProblem = code === BACKTICK_CODE || INVISIBLE_SET.has(code) || WEIRD_SPACE_SET.has(code);
    const isOrphanMark = !isKnownProblem && !hasBase && THAI_COMBINING_MARK_SET.has(code);

    if (isKnownProblem || isOrphanMark) {
      foundCodes.add(code);
      cleaned += MARKER;
    } else {
      cleaned += ch;
    }
    hasBase = true;
  }

  return { cleaned, foundDescriptions: [...foundCodes].map(describeCode) };
}
